import { render, staticRenderFns } from "./RegistroViajeroCard.vue?vue&type=template&id=08332abc&scoped=true"
import script from "./RegistroViajeroCard.vue?vue&type=script&lang=js"
export * from "./RegistroViajeroCard.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajeroCard.vue?vue&type=style&index=0&id=08332abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08332abc",
  null
  
)

export default component.exports